import React, { Component, useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import _ from 'lodash';
import { multipleEmailValidation, validateMultipleEmails, ArrangeEmails } from '../../util/RldAccountUtils';
import { setEmails, resetGenerateFile } from '../../actions/rldToolActions';

export const RldEmail = props => {
  const { email, dictionaryTarget, enableGenerateFile } = useSelector(
    state => ({
      email: state.rldTool.email,
      dictionaryTarget: state.rldTool.dictionary.dictionaryTarget,
      enableGenerateFile: state.rldTool.enableGenerateFile,
    })
  );

  const [emailError, setemailError] = useState([]);
  const [emailTempValues, setemailTempValues] = useState('');
  const [isFirstTimeLoad, setisFirstTimeLoad] = useState(true);  
  const dispatch = useDispatch();

  useEffect(() => {
    const reduceEmails = isFirstTimeLoad ? '' : email.join('\n');

      setemailTempValues(reduceEmails); 
    let isValidate = validateEmailInput(reduceEmails);
    if ((!isValidate) && isFirstTimeLoad) setisFirstTimeLoad(false);
    if (isValidate && email.length > 0 && (!isFirstTimeLoad)) dispatchToReducer(isValidate, email);
  }, [email, dictionaryTarget]); 

  const transformToArrayEmail = (isValidate, emails) => {  
    const splitEmail = Array.isArray(emails) ? 
    emails : 
    emails.replace(/;/g, '\n').replace(/,/g, '\n').split('\n');
    dispatchToReducer(isValidate, splitEmail);
  }

  const dispatchToReducer = (isValidate, emails) => {   
    let viewGenerateFile =
      (emails.length == 1) && (emails[0].trim() == '')
        ? false
        : emails.length > 0 &&
          dictionaryTarget.length > 0 &&
          isValidate;

    dispatch(setEmails(emails, viewGenerateFile));
  };

  const validateEmailInput = email => {
    var badEmails = multipleEmailValidation(email);
    setemailError(badEmails);
    return badEmails.length == 0;
  };

  const handleChange = emails => {
    
    if (isFirstTimeLoad) setisFirstTimeLoad(false);
    
    //disable the generate file button if it is enable,
    // only enable it if it passes validation from onblur
    if (enableGenerateFile) dispatch(resetGenerateFile(false));

    let allowGenerateFile = validateMultipleEmails(emails);
 
    setemailTempValues(emails);

    if(allowGenerateFile){
      setemailError([]);
      dispatch(resetGenerateFile(true && (dictionaryTarget.length > 0)));      
    }
    else{
      validateEmailInput(emails);
    }   
  };

  const handleBlur = emails => {
    let isValidate = validateEmailInput(emailTempValues);

    transformToArrayEmail(isValidate, ArrangeEmails(emailTempValues));
  };

  return (
    <div>
      <div className="emailsetting">
        <div className="controlpositions">
          <div className="controlarea">
            <textarea
              id="rld-email"
              name="rld-userEmails"
              value={emailTempValues ? emailTempValues : null}
              onChange={e => handleChange(e.target.value)}
              onBlur={e => handleBlur(e.target.value)}
              onMouseOut={e => handleBlur(e.target.value)}
              className="rldInputUserEmail"
              placeholder="Notification Email..."
            />
          </div>
          {emailError.length > 0 && !isFirstTimeLoad && (
            <div>
              <div
                className={
                  (emailError.length > 0 && !isFirstTimeLoad) ||
                  (dictionaryTarget.length === 0 &&
                    emailTempValues.length > 0 &&
                    !isFirstTimeLoad)
                    ? 'erroremail erroremailborder'
                    : 'erroremail'
                }
              >
                {emailError.length > 0 && !isFirstTimeLoad ? (
                  <ul>
                    {_.map(emailError, o => (
                      <li key={o}>{o}</li>
                    ))}
                  </ul>
                ) : emailTempValues.length > 0 &&
                  dictionaryTarget.length == 0 &&
                  !isFirstTimeLoad ? (
                  <ul>
                    <li key="noSelectedDictionary">
                      {'Please select dictionary category'}
                    </li>
                  </ul>
                ) : null}
              </div>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};
export default RldEmail;
